export default "__VITE_ASSET__CZ9l6YSC__"